<template>
    
<app-modal v-on:close="$emit('close')" :title="page.business_profile_events_create_title" :description="page.business_profile_events_create_description">

    <template v-slot:default>

        <app-group :slim="true">

            <app-input-text :slim="true" :label="page.business_profile_events_edit_name_label" v-model="inputs.name" :errored="errored.name" :placeholder="page.business_profile_events_edit_name_placeholder" />
            <app-input-image :slim="true" :label="page.business_profile_events_edit_image_label" v-model="inputs.image" :errored="errored.image" :placeholder="page.business_profile_events_edit_image_placeholder" v-on:change="inputs.imageRaw = arguments[0]" />
            <app-input-date :slim="true" :label="page.business_profile_events_edit_date_label" v-model="inputs.date" :errored="errored.date" :placeholder="page.business_profile_events_edit_date_placeholder" />
            <app-input-text :slim="true" :multiline="true" :label="page.business_profile_events_edit_text_label" v-model="inputs.text" :errored="errored.text" :placeholder="page.business_profile_events_edit_text_placeholder" />
           
        </app-group>

    </template>

    <template v-slot:foot>

		<app-button :text="page.business_profile_events_create_button_save" :disabled="!is.valid" :loading="is.submitting" v-on:click="onSaveClick" />
		<app-button :text="page.business_profile_events_create_button_cancel" :disabled="is.submitting" v-on:click="$emit('close')" />

    </template>

</app-modal>

</template>

<script>

import mixinForm from '@/mixin/form.js'
import mixinModal from '@/mixin/modal.js'

export default {

    mixins: [mixinForm, mixinModal],
    
	data: function() {

		return {
			stayAfterSave: true,
			inputs: {
                name: '',
                text: '',
                image: '',
                imageRaw: '',
                date: 0
			},
			rules: {
				name: {
					required: true
				}
			}
		}

	},

	methods: {
        
		onSaveClick: function() {

			this.save('account/profile/events/create', this.inputs).then(function() {

                this.processEvents()
            
                this.$emit('close')

            }.bind(this))

		}

	}
    
}

</script>